import { ServiceFetch } from '../service-fetch'

export default class SchedulePlanListModel extends ServiceFetch {
    getSchedulePlanListBy = (data) => this.authFetch({
        url: 'schedule-plan-list/getSchedulePlanListBy',
        method: 'POST',
        body: JSON.stringify(data),
    }) 

}